import { Form, Input, Tooltip } from "antd";
import React, { useEffect } from "react";
import ComponentLabel from "../../ControlComponents/ComponentLabel";
import { Col, Row } from "react-bootstrap";
import { Controller, useWatch } from "react-hook-form";
import { TableInputProps } from "../TableComponent/TableComponent";

import $ from "jquery";
import { checkRequireFromTemplate } from "../../../Helper/RequestScreenHelper";

type InputFormProps = {
  template: any;
  data: any;
  rowIdx: number;
  colIdx: number;
  col?: any;
  colText?: number;
  colAction?: number;
  name: string;
  control: any;
  canEditDoc: boolean;
  checkActionPage: string;
  buttonType: string;
  onControlChange: (
    controlTemplate: any,
    controlValue: any,
    oldControlValue: any
  ) => any;
};

export const InputControlComponent: React.FC<InputFormProps> = ({
  colIdx,
  rowIdx,
  control,
  name,
  data,
  template,
  col,
  colAction,
  colText,
  canEditDoc,
  checkActionPage,
  buttonType,
  onControlChange,
  ...props
}) => {
  return (
    <Controller
      name={name}
      control={control}
      rules={{
        required: canEditDoc && checkRequireFromTemplate(template, buttonType) && `${template.label}`,
      }}
      render={({ field, formState: { errors, isSubmitted } }) => {
        // if (!field.value || field.value === "") {
        //   field.value = template.attribute.default;
        // }
       let inpId = `${rowIdx}_${colIdx}_${template.label.replaceAll(" ", "_")}`;

        return (
          <>
            <ComponentLabel
              // renderInTable={props.renderInTable}
              col={col}
              colText={colText}
              rowIdx={rowIdx}
              colIdx={rowIdx}
              template={template}
            />
            <Col
              sm={col === undefined ? 12 : 12}
              md={col === undefined ? colAction : 12}
              xs={col === undefined ? 12 : 12}
              xl={col === undefined ? colAction : 12}
              className={"padding-controller"}
            >
              <div
                className={`input-component-container  ${isSubmitted &&
                    errors?.items &&
                    errors?.items[rowIdx] &&
                    errors?.items[rowIdx].layout[colIdx]
                  }`}
              >
                {/* {`${rowIdx}${colIdx}`} */}
                <Input
                  {...field}
                  onBlur={(e) => {
                    field.onChange(e);
                    onControlChange(template, e.target.value, data.value);
                  }}
                  id={inpId}
                  value={field.value ? field.value : undefined}
                  readOnly={!canEditDoc || template.attribute.readonly === "Y"}
                  size={"large"}
                  className="input-component table-input"
                  placeholder={
                    template.type !== "an"
                      ? template.attribute.description
                      : "Auto Number"
                  }
                  maxLength={
                    parseInt(template.attribute.length) === 0
                      ? undefined
                      : parseInt(template.attribute.length)
                  }
                  // defaultValue={template.attribute.default}
                  disabled={
                    !canEditDoc ||
                    template.attribute.readonly === "Y" || template.type === "an"
                  }
                  // onBlur={(e) => onChange(e.target.value)}
                  status={
                    isSubmitted &&
                    errors?.items &&
                    errors?.items[rowIdx] &&
                    errors?.items[rowIdx].layout[colIdx] &&
                    "error"
                  }
                  onKeyDown={(e) => {
                    if (e.code?.toLocaleLowerCase() === "tab") {
                      setTimeout(() => {
                        /**
                         * หลังจากที่มีการ set state จะเรียกดูค่า tabindex ของ element ปัจจุบันเพื่อที่จะเพิ่มค่า tabindex อีก 1 เพื่อที่จะ focus input ถัดไป
                         */
                        let curIndex = document
                          .getElementById(inpId!)
                          ?.getAttribute("tabindex");
                        let nxtIdx = parseInt(curIndex!) + 1;

                        $(
                          "input[tabindex=" +
                          nxtIdx +
                          "], textarea[tabindex=" +
                          nxtIdx +
                          "]"
                        )
                          .focus()
                          .click();
                      }, 300);
                    }
                  }}
                />
                {isSubmitted &&
                  errors?.items &&
                  errors?.items[rowIdx] &&
                  errors?.items[rowIdx].layout[colIdx] && (
                    <small id="Name-help" className="p-error p-d-block">
                      {template.label} is required.
                    </small>
                  )}
              </div>
            </Col>
          </>

        );
      }}
    />
  );
};
// export default InputControlComponent;

export const InputTableComponent: React.FC<TableInputProps> = ({
  name,
  template,
  saveFunc,
  inputRef,
  isEditing,
  onEdit,
  children,
  canEditDoc,
  checkActionPage,
  buttonType,
  rowIdx,
  colIdx,
  toggleEdit,
  ...props
}) => {
  let nId = rowIdx + "_" + colIdx + "_" + template.label;
  const nextTab = () => {
    setTimeout(() => {
      /**
       * หลังจากที่มีการ set state จะเรียกดูค่า tabindex ของ element ปัจจุบันเพื่อที่จะเพิ่มค่า tabindex อีก 1 เพื่อที่จะ focus input ถัดไป
       */
      let curIndex = document.getElementById(nId)?.getAttribute("tabindex");
      let nxtIdx = parseInt(curIndex!) + 1;

      $("input[tabindex=" + nxtIdx + "], textarea[tabindex=" + nxtIdx + "]")
        .focus()
        .click();
    }, 300);
  };

  if (!isEditing) {
    return (
      <div
        style={{ width: "100%" }}
        onClick={() => {
          onEdit();
        }}
      >
        <Input
          autoFocus={isEditing}
          id={nId}
          size="large"
          ref={inputRef}
          className="input-component table-input"
          value={typeof children[1] === "string" ? children[1] : undefined}
          // defaultValue={children[1]}
          placeholder={template.attribute.description}
          readOnly={!canEditDoc || template.attribute.readonly === "Y"}
          disabled={!canEditDoc || template.attribute.readonly === "Y"}
          maxLength={
            parseInt(template.attribute.length) === 0
              ? undefined
              : parseInt(template.attribute.length)
          }
          onKeyDown={(e) => {
            if (e.code?.toLocaleLowerCase() === "tab") {
              nextTab();
            }
          }}
        />
      </div>
    );
  }
  return (
    <>
      <Tooltip title={children[1]} placement="topLeft">
        <Form.Item
          style={{ margin: 0 }}
          name={name}
          rules={[
            {
              required:
                canEditDoc && checkRequireFromTemplate(template, buttonType),
              message: `${template.label}`,
            },
          ]}
        >
          <Input
            autoFocus={isEditing}
            size="large"
            id={nId}
            ref={inputRef}
            value={typeof children[1] === "string" ? children[1] : undefined}
            // defaultValue={children[1]}
            className="input-component table-input"
            readOnly={!canEditDoc || template.attribute.readonly === "Y"}
            disabled={!canEditDoc || template.attribute.readonly === "Y"}
            placeholder={template.attribute.description}
            maxLength={
              parseInt(template.attribute.length) === 0
                ? undefined
                : parseInt(template.attribute.length)
            }
            onPressEnter={saveFunc}
            onBlur={(e) => {
              e.preventDefault();
              saveFunc();
            }}
            onKeyDown={(e) => {
              if (e.code?.toLocaleLowerCase() === "tab") {
                nextTab();
              }
            }}
          />
        </Form.Item>
      </Tooltip>
    </>
  );
};
